export default __webpack_public_path__ + "static/media/phone.ecaf9eee.svg";